'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var removeQuotes = function removeQuotes(string) {
  var unquotedString = void 0,
      matchRegExp = /^"(.*)"$/;
  if (typeof string === 'string' || string instanceof String) {
    if (string.indexOf("'") > -1 // safari workaround
    ) matchRegExp = /^'(.*)'$/;
    unquotedString = string.match(matchRegExp)[1].replace(/`/g, '"');
  }

  return unquotedString;
};

var getSassConstants = exports.getSassConstants = function getSassConstants() {
  if (window.getComputedStyle && window.getComputedStyle(document.body, '::before')) {
    var style = window.getComputedStyle(document.body, '::before');
    if (style && style.content) return JSON.parse(removeQuotes(style.content));else return {};
  }

  return {};
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/utils/index.js
// module id = 636
// module chunks = 0